module.exports = __webpack_public_path__ + "static/img/2.d0a58bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hlw/2.png
// module id = Q60Z
// module chunks = 1